import { Button } from '@breezeventures/ui-kit/button';
import { DropdownMenu } from '@breezeventures/ui-kit/dropdown-menu';
import { Icon } from '@breezeventures/ui-kit/next/icon';

type Props = {
  value: number;
  options: readonly number[];
  onPageSizeChange: (value: number) => void;
};

export const PageSizeSelect = ({ value, options, onPageSizeChange }: Props) => {
  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <Button type="button" size="s" variant="secondary">
          {value} lines per page
          <Button.Icon>
            <Icon
              name="chevron-down"
              size={24}
              version="v1"
              className={`
                size-4 transition-transform duration-200
                group-data-[state=open]:rotate-180
              `}
            />
          </Button.Icon>
        </Button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content>
        {options.map((option) => (
          <DropdownMenu.Item
            key={option}
            isSelected={option === value}
            onClick={() => onPageSizeChange(option)}
          >
            {option}
            <DropdownMenu.Indicator />
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};
